import React, { useState, Fragment, useEffect } from "react";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  vendor_role_management_get_all,
  vendor_edit_role,
  vendor_delete_role,
} from "../../../store/actions/vendorRoleManagement/vendorRoleManagement";
import { PopupActionButton } from "../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Accordion from "react-bootstrap/Accordion";
import { Col, Form, Row, Table, Image, Modal, Button } from "react-bootstrap";
import { NewInputText } from "../../reusableComponents/inputReusableComponent/InputBoxComponent";
import Card from "react-bootstrap/Card";
import Alert from "react-s-alert";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import SlidingComponent from "../../reusableComponents/slidingToggleComponent/SlidingComponent";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

const TableMobileView = (props) => {
  const [show, setShow] = useState(false);

  //state
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [state, setState] = useState({
    search: "",
  });

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const [roles, setrolesData] = useState([]);
  const onSearchChange = (e) => {
    let tempdata = props.rolesData.roles.filter((items) =>
      items.role_name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    if (e.target.value) {
      setrolesData(tempdata);
    } else {
      setrolesData(props.rolesData.roles);
    }
  };

  useEffect(() => {
    setrolesData(props.rolesData.roles);
  }, [props.rolesData.roles]);

  const filterData = (filter, closeModel) => {
    let tempdata = [];
    if (filter === 1) {
      tempdata = props.rolesData.roles.filter((items) => items.active === true);
      setrolesData(tempdata);
    } else if (filter === 2) {
      tempdata = props.rolesData.roles.filter(
        (items) => items.active === false
      );
      setrolesData(tempdata);
    } else {
      setrolesData(props.rolesData.roles);
    }
    closeModel();
  };

  const getData = () => {
    if (props.restaurant._id) {
      const token = props.auth.user.accessToken;
      // console.log(token, props.restaurant._id);
      props.vendor_role_management_get_all(token, props.restaurant._id);
    }
  };

  useEffect(() => {
    getData();
  }, [props.restaurant._id]);

  const editRoleFun = (data, setErrors, handleCloseEditRole) => {
    if (!data.role_name) {
      setErrors({ role_name: "Please enter a role name" });
    } else if (!data.role_desc) {
      setErrors({ role_desc: "Please enter a role description." });
    } else if (!("roleRemove" in data)) {
      setErrors({ roleRemove: "Please select an option." });
    } else {
      const token = props.auth.user.accessToken;
      const formData = {
        _id: data._id,
        role_name: data.role_name,
        description: data.role_desc,
        isDefaultRole: data.role_default ? true : false,
        isRemovable: data.roleRemove,
      };
      props.vendor_edit_role(token, formData, () => {
        Alert.success(`<h4>Role edited successfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        handleCloseEditRole();
        getData();
      });
    }
  };

  const deleteRole = (id, handleClose) => {
    const token = props.auth.user.accessToken;

    props.vendor_delete_role(token, id, () => {
      Alert.success(`<h4>Role deleted successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      handleClose();
      getData();
    });
  };

  const changeStatus = (_id, statuschecked) => {
    const token = props.auth.user.accessToken;
    const formData = {
      _id: _id,
      active: statuschecked,
    };
    props.vendor_edit_role(token, formData, () => {
      Alert.success(`<h4>Role status changed successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      getData();
    });
  };

  return (
    <React.Fragment key={props.index}>
      <SwipeableList className={`swipeOffer`}>
        {({ swipeOffer, ...rest }) => (
          <div className={`${show ? "swipeOffer" : ""}`}>
            <SwipeableListItem
              swipeLeft={{
                content: (
                  <div className="d-flex swipeOption">
                    <ViewModel data={props.data} mobileView />
                    <DeleteModal
                      data={props.data}
                      mobileView
                      onClick={(handleCloseBlockUser) =>
                        props.deleteRole(props.data._id, handleCloseBlockUser)
                      }
                    />
                    <EditModel
                      data={props.data}
                      editRoleFun={editRoleFun}
                      mobileView
                    />

                    {/* <PopupActionButton
                        buttonText={
                          <div>
                            <i
                              style={{ color: "#ffffff" }}
                              class="fa fa-pencil"
                              aria-hidden="true"
                            ></i>
                            <br />
                            Edit
                          </div>
                        }
                        buttonType="button"
                        buttonClass="smallsave"
                        editIcon={true}
                         onClick={()=>{
                          return( <EditModel
                            data={props.data}
                            editRoleFun={editRoleFun}
                          />)}}
                      /> */}
                  </div>
                ),
                action: () => setShow(true),
              }}
              swipeRight={{
                // content: <div>Revealed content during swipe</div>,
                action: () => setShow(false),
              }}
              {...rest}
            >
              <Card className="main-reusable-accordion">
                <Accordion.Toggle as={Card.Header} eventKey={props.index + 1}>
                  <div className="d-flex align-items-center">
                    <div className="card-header-left f10-500">
                      {" "}
                      {props.data.role_name}
                    </div>
                    <div
                      className="card-header-middle f10-500"
                      style={{ width: "17%" }}
                    >
                      0
                    </div>
                    <div
                      className="card-header-right f10-500"
                      style={{ width: "47%", textAlign: "left" }}
                    >
                      {props.data.description}
                    </div>
                  </div>
                </Accordion.Toggle>
              </Card>
            </SwipeableListItem>
          </div>
        )}
      </SwipeableList>
    </React.Fragment>
  );
};

const ViewModel = (props) => {
  const [ShowViewRole, setShowViewRole] = useState(false);
  const handleShowViewRole = () => setShowViewRole(!ShowViewRole);

  return (
    <>
      {props.mobileView ? (
        <button
          type="button"
          className="n_button_d_status font_18_m "
          style={{ backgroundColor: "#2196F3", color: "white" }}
          onClick={handleShowViewRole}
        >
          View
        </button>
      ) : (
        <div className="enIconBtn mr-3" onClick={handleShowViewRole}>
          <Image
            src={require("../../../assets/images/UserManagement/eye.svg")}
            alt="Edit"
            title="Edit"
            fluid
          />
        </div>
      )}
      <Modal show={ShowViewRole} onHide={handleShowViewRole} centered size="md">
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">
              View Roles Privileges
            </Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <div className="f14-400">Role Type</div>
          <div className="f16-700">{props.data.role_name}</div>
          <div className="f14-400 mt-4">Role Short Description</div>
          <div className="f16-700">{props.data.description}</div>
          <div className="f14-400 mt-4">No. of users</div>
          <div className="f16-700">
            {/* <Image
                src={require("../../../assets/images/UserManagement/pencil.svg")}
                alt="Edit"
                title="Edit"
                fluid
              />
              Sophia Peter */}
            -
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

//   const Filter = (props) => {
//     const [open, setOpen] = useState(false);
//     const [state, setState] = useState(0);
//     const onOpenModal = () => setOpen(true);
//     const onCloseModel = () => setOpen(false);
//     return (
//       <>
//         <div
//           onClick={onOpenModal}
//           className="d-flex align-items-center justify-content-between cursor"
//         >
//           <Image
//             alt="filter"
//             title="filter"
//             width="20px"
//             src={require("../../../assets/images/ActionImages/image/filter.svg")}
//           />
//           <div className="f12-500 text-blue mx-2">Filter</div>
//           <i className="fa fa-angle-down text-blue" aria-hidden="true"></i>
//         </div>
//         <Modal show={open} onHide={onCloseModel} centered>
//           <Modal.Header className="py-0 pt-2 border-0" closeButton>
//             <Modal.Title>Filter</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="f16-500">
//             Select one relevant option from below
//             <Media query="(min-width: 991px)"></Media>
//             <Media query="(max-width: 991px)"></Media>
//             <div className="row mt-4">
//               <div className="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 0 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(0);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">All</div>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 1 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(1);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">Active</div>
//                   </div>
//                 </div>
//               </div>
//               <div class="col-6 col-md-4 mb-4">
//                 <div
//                   className={`status-selected-button-box f16-500 ${
//                     state === 2 && `sts_sld_btn_box_a`
//                   }`}
//                   type="button"
//                   onClick={() => {
//                     setState(2);
//                   }}
//                 >
//                   <div class="row justify-content-center">
//                     <div class="">Inactive</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer className="justify-content-start d-flex border-0">
//             <Button
//               variant="outline-secondary"
//               className="btn-md "
//               onClick={() => {
//                 setState(0);
//                 props.filterData(1, onCloseModel);
//               }}
//             >
//               Reset Filter
//             </Button>
//             <Button
//               variant="danger"
//               className="btn-md "
//               onClick={() => {
//                 props.filterData(state, onCloseModel);
//               }}
//             >
//               Apply Filter
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </>
//     );
//   };

const DeleteModal = (props) => {
  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);
  return (
    <React.Fragment>
      {props.mobileView ? (
        <button
          type="button"
          className="n_button_d_status font_18_m popup-cancel-button"
          onClick={handleShowBlockUser}
        >
          <div>
            <i
              style={{ color: "#ffffff" }}
              class="fa fa-trash"
              aria-hidden="true"
            ></i>
            <br />
            Delete
          </div>
        </button>
      ) : (
        <Fragment>
          {props.redButton ? (
            <div className="enIconBtn mr-3" onClick={handleShowBlockUser}>
              <Image
                src={require("../../../assets/images/UserManagement/Delete.svg")}
                alt="Delete"
                title="Delete"
                fluid
              />
            </div>
          ) : (
            <button
              type="button"
              className="enBtnoutlineGrayIcon"
              onClick={handleShowBlockUser}
            >
              <SVG
                src={require("../../../assets/images/UserManagement/Delete.svg")}
              />
            </button>
          )}
        </Fragment>
      )}
      <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the {props.name} ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseBlockUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={() => {
              handleCloseBlockUser();
              props.onClick(handleCloseBlockUser);
            }}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

const EditModel = (props) => {
  const [showEditRole, setShowEditRole] = useState(false);
  const handleShowEditRole = () => setShowEditRole(true);
  const handleCloseEditRole = () => setShowEditRole(false);
  const [data, setData] = useState({ roleRemove: false });
  useEffect(() => {
    setData({
      _id: props.data._id,
      role_name: props.data.role_name,
      role_desc: props.data.description,
      role_default: props.data.isDefaultRole,
      roleRemove: props.data.isRemovable,
    });
  }, [props.data]);

  const [errors, setErrors] = useState({});
  const onChange = (e) => {
    setErrors({});
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const editRoleFun = (e) => {
    e.preventDefault();
    props.editRoleFun(data, setErrors, handleCloseEditRole);
  };
  return (
    <>
      {props.mobileView ? (
        <button
          type="button"
          className="n_button_d_status font_18_m "
          style={{ backgroundColor: "#37AC1E", color: "white" }}
          onClick={handleShowEditRole}
        >
          Edit
        </button>
      ) : (
        <div className="enIconBtn mr-3" onClick={handleShowEditRole}>
          <Image
            src={require("../../../assets/images/UserManagement/pencil.svg")}
            alt="Edit"
            title="Edit"
            fluid
          />
        </div>
      )}
      <Modal
        show={showEditRole}
        onHide={handleCloseEditRole}
        centered
        size="lg"
      >
        <Modal.Header className="px-4 border-0" closeButton>
          <div>
            <Modal.Title className="f20-700 pb-2">Edit Role</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body className="px-4">
          <>
            <Form className="row">
              <Col lg="6">
                <NewInputText
                  labelText="Role Name"
                  extraClass="mb-4 w-100"
                  name="role_name"
                  value={data.role_name}
                  onChange={onChange}
                  errorTrue={errors.role_name}
                />
                <div className="mb-2" style={{ color: "red" }}>
                  {errors.role_name}
                </div>
                <NewInputText
                  labelText="Role Description"
                  extraClass="mb-3 w-100"
                  multiline={true}
                  rows="5"
                  name="role_desc"
                  value={data.role_desc}
                  onChange={onChange}
                  errorTrue={errors.role_desc}
                />
                <div className="mb-2" style={{ color: "red" }}>
                  {errors.role_desc}
                </div>
                <div className="d-flex align-items-center pb-5">
                  <Form.Check
                    label="1"
                    inline
                    className="enCheckBoxOnly"
                    name="role_default"
                    checked={data.role_default}
                    onChange={() => {
                      setData({
                        ...data,
                        role_default: !data.role_default,
                      });
                    }}
                    errorTrue={errors.role_default}
                  />
                  <div className="f12-500">Set As Default Role</div>
                </div>
                <div className="f14-700 mb-4">Role Removable?</div>
                <div className="checkbox-bank-account justify-content-start">
                  <label className="enRadioWithText small mr-3">
                    <span className="f14-500">Yes</span>
                    <input
                      type="radio"
                      name="roleRemove"
                      checked={data.roleRemove}
                      onChange={() => {
                        setData({ ...data, roleRemove: true });
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <label className="enRadioWithText small f18-500">
                    <span className="f14-500">No</span>
                    <input
                      type="radio"
                      name="roleRemove"
                      checked={!data.roleRemove}
                      onChange={() => {
                        setData({ ...data, roleRemove: false });
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </div>
                <div className="mb-2" style={{ color: "red" }}>
                  {errors.roleRemove}
                </div>
                <div className="d-flex align-items-center py-4">
                  <Button
                    variant="outline-secondary"
                    className="btn150px btn-lg mr-4 px-5"
                    onClick={handleCloseEditRole}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="danger"
                    onClick={(e) => {
                      // setState(true);
                      editRoleFun(e);
                    }}
                    className="btn150px btn-lg px-5"
                  >
                    Save
                  </Button>
                </div>
              </Col>
            </Form>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};
TableMobileView.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  restaurant: PropTypes.object.isRequired,
  rolesData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  restaurant: state.onboarding.restaurantDetails,
  rolesData: state.vendorRoleManagement,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  vendor_role_management_get_all,
  vendor_edit_role,
  vendor_delete_role,
})(TableMobileView);
